var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"document",attrs:{"id":"ethics"}},[_c('Title',{attrs:{"text":_vm.$t('ethics.title')}}),_c('Common',{attrs:{"text":_vm.$t('ethics.paragraph01')}}),_c('Common',{attrs:{"text":_vm.$t('ethics.paragraph02')}}),_c('div',[_c('Ul',{attrs:{"section":"ethics","items":[
        _vm.$t('ethics.bullets.bullet01'),
        _vm.$t('ethics.bullets.bullet02'),
        _vm.$t('ethics.bullets.bullet03'),
        _vm.$t('ethics.bullets.bullet04'),
        _vm.$t('ethics.bullets.bullet05')
      ]}})],1),_c('Common',{attrs:{"text":_vm.$t('ethics.paragraph03')}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }